import { CompanyClassificationType } from '../../constants-types';

export interface CreateCompanyResponse {
    companyName: string;
    statusCode: number;
    companyClassificationType: CompanyClassificationType;
    validationResult?: ValidationResult;
}

export enum ValidationResult {
    Unknown = 'Unknown',
    DuplicateCompanyName = 'DuplicateCompanyName'
}
